import EntrantDetailModal from './EntrantDetailModal';

export default EntrantDetailModal;
